export const CREATE_PIN_TEXT =
  'Please create a 6-10 digit security PIN that will be used to E-sign and Lock/Unlock the EMR. You can manage your PIN from user profile';
export const CREATE_PIN_TITLE = 'Create Security PIN';
export const SUBMIT_BUTTON_TEXT = 'Create PIN';
